import { call, put, takeLatest } from "redux-saga/effects";
import { thongKeCanXuLyApi } from "../../../api/dashboard/thongKeCanXuLyApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eThongKeCanXuLyActionTypeIds,
  IThongKeCanXuLyActionTypes,
} from "../../action-types/dashboard/IThongKeCanXuLyActionTypes";
import { rootActions } from "../../actions/rootActions";
import { RONG_THONG_KE } from "../../reducers/dashboard/thongKeCanXuLyReducer";

export function* thongKeCanXuLySaga(): any {
  // takeLatest: bấm Làm mới liên tục hay đổi kỳ nhanh thì chỉ lần cuối được tính.
  yield takeLatest(eThongKeCanXuLyActionTypeIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IThongKeCanXuLyActionTypes): any {
  const { hoc_ky, nam_hoc } = action.payload as {
    hoc_ky: number;
    nam_hoc: string;
  };
  if (!hoc_ky || !nam_hoc) return;
  try {
    const res: IBaseRespone = yield call(
      thongKeCanXuLyApi.Select,
      hoc_ky,
      nam_hoc,
    );
    if (res.is_success) {
      yield put(
        rootActions.dashboard.thongKeCanXuLy.LOAD_SUCCESS({
          hoc_ky,
          nam_hoc,
          data: { ...RONG_THONG_KE, ...((res.data as any) ?? {}) },
        }),
      );
    } else {
      yield put(
        rootActions.dashboard.thongKeCanXuLy.LOAD_ERRR(res.message ?? "Có lỗi"),
      );
    }
  } catch {
    yield put(rootActions.dashboard.thongKeCanXuLy.LOAD_ERRR("Có lỗi"));
  }
}
